import {ROOT_URL, MAX_ERROR_TEXT_LEN} from '@/store';
import store from '@/store';

const REQUEST_LINK = '/page_templates/template_struct/?auto=1';

function getTemplateStructure(handler) {
  fetch(ROOT_URL + REQUEST_LINK, {
    method: 'GET',
    credentials: 'include',
  }).then(async function(response) {
    if (response.status != 200) {
      store.commit(
          'critical_error_mut',
          {
            type: 'break_page_templates',
            shortInfo: 'Ошибка при запросе структуры шаблонов страниц!',
            fullInfo: `На сервере произошла ошибка! Возможно идут плановые работы, либо ваш случай уникален и нужно обратиться в поддержку. Статус: ${response.status} Причина: ${(await response.text()).trimLen(MAX_ERROR_TEXT_LEN)}`,
          },
      );
      return;
    }

    const data = await response.json();
    // const result = [];
    // data.rows.forEach(function(rowItem) {
    //   rowItem.values.in_fast_panel = true;
    //   result.push(rowItem.values);
    // });
    handler(data);
  }).catch((error) => {
    console.log('error', error);
    store.commit(
        'critical_error_mut',
        {
          type: 'break_page_templates',
          shortInfo: 'Нет соединения с сервером!',
          fullInfo: 'Проверьте подключение к интернету или попробуйте зайти позже.',
        },
    );
  });
}

export default getTemplateStructure;
